import script from "./StorageDefaultsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageDefaultsModal.vue?vue&type=script&setup=true&lang=js"

import "./StorageDefaultsModal.vue?vue&type=style&index=0&id=fb348302&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb348302"]])

export default __exports__